import { render, staticRenderFns } from "./addFirstPlaning_A.vue?vue&type=template&id=280c61a4&scoped=true"
import script from "./addFirstPlaning_A.vue?vue&type=script&lang=js"
export * from "./addFirstPlaning_A.vue?vue&type=script&lang=js"
import style0 from "./addFirstPlaning_A.vue?vue&type=style&index=0&id=280c61a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c61a4",
  null
  
)

export default component.exports